import { render } from "./DecontAgent.vue?vue&type=template&id=e32e6d40"
import script from "./DecontAgent.vue?vue&type=script&lang=js"
export * from "./DecontAgent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__